import { render, staticRenderFns } from "./Logic_One.vue?vue&type=template&id=5675e36a&scoped=true"
import script from "./Logic_One.vue?vue&type=script&lang=js"
export * from "./Logic_One.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5675e36a",
  null
  
)

export default component.exports